// Month based on 1 - 12 format.
const JULY = 7;

const startOfSchoolYear = (date = new Date()) => {
  // Add 1 because getMonth returns the month number between 0 - 11.
  const currentMonth = date.getMonth() + 1;
  const currentYear = date.getFullYear();
  const yearStart = currentMonth < JULY ? currentYear - 1 : currentYear;

  return new Date(`${yearStart}-07-01T00:00:00`);
};

export default startOfSchoolYear;
